function StatusBadge({ status }) {
  if (!status) return null

  const statusColors = {
    'Active': '#2e7d32',
    'Next Up': '#1565c0',
    'Later': '#6a1b9a',
    'Waiting For': '#ef6c00',
    'Monitor': '#00838f',
    'Paused': '#757575',
    'Completed': '#388e3c',
    'Cancelled': '#c62828',
    'Skipped': '#8e24aa'
  }

  return (
    <span
      className="pill"
      style={{
        background: statusColors[status] || '#607d8b',
        color: 'white'
      }}
    >
      {status}
    </span>
  )
}

export default StatusBadge